export const formatarDadosGantt = (tarefasOriginais: any[]) => {
  const formatarData = (data: string, hora: string | null) => {
    if (!hora) return null; // Retorna null se não houver hora

    const [ano, mes, dia] = data.split("-");
    const [horas, minutos] = hora.split(":");
    try {
      const result = new Date(
        parseInt(ano),
        parseInt(mes) - 1,
        parseInt(dia),
        parseInt(horas),
        parseInt(minutos)
      );
      return result;
    } catch (error) {
      console.error("Erro ao formatar data:", { data, hora, error });
      return null;
    }
  };

  const formatarDuracao = (minutos: number) => {
    if (!minutos) return "0h";
    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;
    return `${horas}h${minutosRestantes > 0 ? ` ${minutosRestantes}min` : ""}`;
  };

  const tarefasFormatadas = tarefasOriginais
    .map((tarefa) => {
      // Verifica se tem as datas necessárias
      if (!tarefa.data_atividade) {
        console.warn("Tarefa sem data de atividade:", tarefa);
        return null;
      }

      // Se não tiver horário de início ou fim, usa valores padrão
      const start_date = formatarData(
        tarefa.data_atividade,
        tarefa.starttime || "00:00"
      );
      const end_date = formatarData(tarefa.data_atividade, tarefa.endtime || "23:59");

      // Se ainda assim não conseguir criar as datas, pula esta tarefa
      if (!start_date || !end_date) {
        console.warn("Não foi possível criar datas para a tarefa:", tarefa);
        return null;
      }

      return {
        id: tarefa.activityid.toString(),
        text: `${tarefa.apptnumber} - ${tarefa.tecnico.split("-")[2]}`,
        start_date,
        end_date,
        duration_planned: formatarDuracao(tarefa.duration || 0),
        status: tarefa.status || "pending",
        raw_data: {
          matricula_tim: tarefa.matricula_tim,
          filial: tarefa.filial,
          tecnico_completo: tarefa.tecnico,
          centro_custo: tarefa.centro_custo,
        },
      };
    })
    .filter(Boolean); // Remove os itens null

  return { data: tarefasFormatadas };
};
